import React from "react"
import { useLegendData } from "./constants/legendData"
import LegendItem from "./LegendItem"

const SessionStatusKey = () => {
  const { sessionStatusData } = useLegendData()

  return (
    <div className="legend-container">
      <h6 className="mb-2">Session status key</h6>
      <ul className="list-unstyled mb-0">
        {sessionStatusData.map((item, index) => (
          <LegendItem key={index} Icon={item.Icon} iconColor={item.iconColor} label={item.label} />
        ))}
      </ul>
    </div>
  )
}

export default SessionStatusKey
